/* eslint-disable import/prefer-default-export */
import get from 'lodash.get';

export const filterCardsForPublish = (items) => {
  const normalizeItems = items.map((item) =>
    get(item, 'fields')
      ? { ...get(item, 'fields'), ...{ id: get(item, 'sys.id') } }
      : item
  );

  return normalizeItems;
};

export const filterCardForPublish = (item) => {
  const now = +new Date();

  return new Date(item.date) <= now ? item : null;
};

export const filterRecommendedCardsForPublish = (items) => {
  return items.slice(0, 3);
};
